import React, { useRef, useState } from 'react';
import { Avatar, Button, CircularProgress, TextField, Typography } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { repliValidator } from '../../../components';

import useStyles from './TokenResend.style';
import Alert from '@material-ui/lab/Alert';

const LoginTextField = props => {
    return <TextField
        variant="outlined"
        margin="normal"
        required
        fullWidth
        {...props}
    />
};

const TokenResend = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [submitted, setSubmitted] = useState(false);
    const [sending, setSending] = useState(false);
    const [sendResult, setSendResult] = useState();

    const [email, setEmail] = useState('');

    const validator = useRef(repliValidator());

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitted(true);

        const isValid = validator.current.allValid();
        if (!isValid) {
            validator.current.showMessages();
            return;
        }

        setSending(true);
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_AUTH}/resendToken`, {
                method: 'post',
                body: new URLSearchParams({
                    email: email,
                })
            });
            if (!response.ok) {
                let json = await response.json();
                setSendResult({ severity: 'error', message: json.message });
                return;
            };
            setSendResult({ severity: 'success', message: t('tokenResend.message.success') });
        } catch (error) {
            console.log(error.message);
            setSendResult({ severity: 'error', message: `${t('tokenResend.message.error')}. ${t('common.message.error.seeLog')}` });
        } finally {
            setSending(false);
        };
    };

    return (
        <div className={classes.paper}>
            <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                {t('tokenResend.text.question')}
            </Typography>
            {t('tokenResend.text.help')}
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <LoginTextField
                    label={t('common.form.label.email')}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    error={submitted && !validator.current.fieldValid('email')}
                    helperText={validator.current.message('email', email, 'required|email')}
                    onChange={e => setEmail(e.target.value)}
                    value={email}
                />
                {
                    sendResult &&
                    <Alert severity={sendResult.severity}>{sendResult.message}</Alert>
                }
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    disabled={sending}
                >
                    {t('tokenResend.buttonLabel.resendToken')}
                    {sending && <CircularProgress size={24} className={classes.buttonProgress} />}
                </Button>
                <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    component={RouterLink}
                    to="/provider/login"
                >
                    {t('common.form.label.cancel')}
                </Button>
            </form>
        </div>
    );
};

export default TokenResend;